<template>
    <div class="form-group row mb-0 justify-content-center">
        <div class="col-md-11">
            <div class="row justify-content-center align-items-end">
                <div class="col-12 col-md-4 text-center text-md-left mb-3 mb-md-0">
                    <a v-if="$route.path != '/enrolment/payment' " href="#" class="link" @click.prevent="processStage($event, true)">
                        <translate>Save and continue later</translate>
                    </a>
                </div>
                <div class="col-12 col-md text-center text-md-right ml-md-auto">
                    <LoaderedButton v-if="prev" :clickHandler="proxiedHandler('prev')" btnClasses="btn btn-secondary mr-3" :content="backBtnText" />
                    <LoaderedButton type="submit" :isValid="isValid" :clickHandler="proxiedHandler('submitHandler')" btnClasses="btn btn-primary" :content="nextBtnText" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderedButton from '@C/LoaderedButton';
export default {
    name: 'Footer',
    computed: {
        backBtnText() {
            return this.backBtn || this.$gettext('Back');
        },
        nextBtnText() {
            if(this.$route.path === '/enrolment/register' || this.$route.path === '/enrolment/personal' || this.$route.path === '/enrolment/home-address' || this.$route.path === '/enrolment/subscription') {
              return this.nextBtn || this.$gettext('Next');
            } else {
              return this.nextBtn || this.$gettext('Checkout');
            }
        }
    },
    methods: {
        proxiedHandler(action) {
            return () => {
                window.scrollTo(0, 0);
                this[action]();
            }
        }
    },
    props: {
        processStage: {
            type: Function,
            required: true
        },
        submitHandler: {
            type: Function,
            required: true
        },
        prev: {
            type: Function,
            default: null
        },
        backBtn: {
            type: String,
        },
        nextBtn: {
            type: String,
        },
        isValid: {
            type: Boolean,
            default: true
        }
    },
    components: {
        LoaderedButton
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Footer.vue